import React from 'react';
import { useOptionConfigurator } from './OptionConfiguratorContext';

interface Props {
    children: React.ReactNode;
}

/**
 * Renders its children only OUTSIDE the showroom (i.e. the authenticated buyer/seller flow). In the
 * anonymous showroom — where deadlines, signatures and other account-bound concerns are irrelevant —
 * the children are omitted. Use this for purely presentational "hide in the showroom" cases; for
 * control-flow decisions (early returns, computed flags, hook arguments) read `isShowroom` from
 * `useOptionConfigurator()` directly instead.
 *
 * Must be rendered within an OptionConfiguratorProvider.
 */
export const ShowroomHidden: React.FC<Props> = ({ children }) => {
    const { isShowroom } = useOptionConfigurator();
    return isShowroom ? null : <>{children}</>;
};

/**
 * Renders its children only INSIDE the showroom. The complement of {@link ShowroomHidden}.
 *
 * Must be rendered within an OptionConfiguratorProvider.
 */
export const ShowroomOnly: React.FC<Props> = ({ children }) => {
    const { isShowroom } = useOptionConfigurator();
    return isShowroom ? <>{children}</> : null;
};
